import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { IdCard, SearchCheck } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, RowAction } from '@/components/DataTable/types'
import { fetchGroups, type AdminGroupRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'
import { GROUP_OPS_STR as S } from './groupOpsApi'

/**
 * A4.02 — Kengaytirilgan qidiruv. JONLI `/admin/groups` (dialogs WHERE type IN
 * group,channel) + tur/forum/a'zolar-soni bo'yicha filtrlar va tez-qidiruv.
 */
export function GroupAdvancedSearch() {
  const t = useT()
  const navigate = useNavigate()

  const rowActions = useMemo<RowAction<AdminGroupRow>[]>(
    () => [
      {
        id: 'card',
        label: t.users.viewCard,
        icon: <IdCard size={13} />,
        onSelect: (r) => navigate(`/groups/${r.id}`),
      },
    ],
    [t, navigate],
  )

  const columns = useMemo<AdminColumn<AdminGroupRow>[]>(
    () => [
      {
        key: 'type',
        header: t.col.type,
        type: 'enum',
        width: 110,
        filterable: true,
        options: [
          { value: 'group', label: t.groups.group, status: 'active' },
          { value: 'channel', label: t.groups.channel, status: 'review' },
        ],
      },
      { key: 'title', header: t.col.title, type: 'text', minWidth: 200, filterable: true },
      { key: 'username', header: t.col.username, type: 'text', width: 160, filterable: true },
      {
        key: 'member_count',
        header: t.groups.members,
        type: 'number',
        width: 120,
        filterable: true,
      },
      { key: 'is_forum', header: t.groups.forum, type: 'bool', width: 90, filterable: true },
      { key: 'created_at', header: t.col.registered, type: 'date', width: 150, filterable: true },
    ],
    [t],
  )

  const fetcher = useCallback(fetchGroups, [])

  return (
    <>
      <PageHeader title={S.advancedSearch} screenId="A4.02" description={S.advancedSearchNote} />
      <DataTable<AdminGroupRow>
        screenId="A4.02"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        rowActions={rowActions}
        exportable
        emptyState={{ icon: <SearchCheck size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
